import { RouterProvider } from "react-router-dom";
import { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import { Toaster } from "react-hot-toast";
import Router from "./routes/Router";

function App() {
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);

  return (
    <div className=" ">
      <Particles
        Particles
        id="tsparticles"
        url="particles.json"
        init={particlesInit}
        loaded={particlesLoaded}
      ></Particles>
      <RouterProvider router={Router}></RouterProvider>
      <Toaster />
    </div>
  );
}

export default App;
